import { GET_PLANS, GET_ACCOUNT_DETAIL, GET_API_KEYS, CREATE_API_KEY, REVOKE_API_KEY, DELETE_API_KEY, GET_COMPANIES, CREATE_COMPANY, UPDATE_COMPANY_STATUS, UPDATE_COMPANY, GET_COMPANY_MEMBERS, ADD_COMPANY_MEMBER, UPDATE_MEMBER_PERMISSIONS, UPDATE_MEMBER_STATUS, GET_MEMBER_BY_ID, GET_COMPANY_ROLES, GET_MODULES } from "../Types/types";

let intialState = {
    plans: [],
    isTestLoading: true,
    editTemplate: false,
    isTemplate: false,
    apiKeys: [],
    companies: [],
    companiesTotal: 0,
    companyMembers: [],
    companyMembersTotal: 0,
    companyRoles: [],
    modules: [],
}


export default function settingReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_PLANS:
            stateCopy.plans = action.payload;
            return stateCopy;
        case GET_ACCOUNT_DETAIL:
            stateCopy.accountDetail = action.payload
            return stateCopy;
        case GET_API_KEYS:
            stateCopy.apiKeys = action.payload;
            return stateCopy;
        case CREATE_API_KEY:
            stateCopy.apiKeys = [action.payload, ...stateCopy.apiKeys];
            return stateCopy;
        case REVOKE_API_KEY:
            stateCopy.apiKeys = stateCopy.apiKeys.map(key =>
                key.id === action.payload.id ? action.payload : key
            );
            return stateCopy;
        case DELETE_API_KEY:
            stateCopy.apiKeys = stateCopy.apiKeys.filter(key => key.id !== action.payload);
            return stateCopy;
        case GET_COMPANIES:
            stateCopy.companies = Array.isArray(action.payload.data) ? action.payload.data : Array.isArray(action.payload) ? action.payload : [];
            stateCopy.companiesTotal = action.payload.total ?? stateCopy.companies.length;
            return stateCopy;
        case CREATE_COMPANY:
            stateCopy.companies = [action.payload, ...stateCopy.companies];
            return stateCopy;
        case UPDATE_COMPANY_STATUS:
            stateCopy.companies = stateCopy.companies.map(c =>
                c.id === action.payload.id ? { ...c, is_active: action.payload.is_active } : c
            );
            return stateCopy;
        case UPDATE_COMPANY:
            stateCopy.companies = stateCopy.companies.map(c =>
                c.id === action.payload.id ? { ...c, ...action.payload } : c
            );
            return stateCopy;
        case GET_COMPANY_ROLES:
            stateCopy.companyRoles = Array.isArray(action.payload) ? action.payload : [];
            return stateCopy;
        case GET_MODULES:
            stateCopy.modules = Array.isArray(action.payload) ? action.payload : [];
            return stateCopy;
        case GET_COMPANY_MEMBERS:
            stateCopy.companyMembers = Array.isArray(action.payload)
                ? action.payload
                : Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : [];
            stateCopy.companyMembersTotal = action.payload?.pagination?.total ?? stateCopy.companyMembers.length;
            return stateCopy;
        case ADD_COMPANY_MEMBER:
            stateCopy.companyMembers = [action.payload, ...stateCopy.companyMembers];
            return stateCopy;
        case UPDATE_MEMBER_PERMISSIONS:
            stateCopy.companyMembers = stateCopy.companyMembers.map(m =>
                m.id === action.payload.id ? { ...m, ...action.payload } : m
            );
            return stateCopy;
        case UPDATE_MEMBER_STATUS:
            stateCopy.companyMembers = stateCopy.companyMembers.map(m =>
                m.id === action.payload.id ? { ...m, is_active: action.payload.is_active } : m
            );
            return stateCopy;
        case GET_MEMBER_BY_ID:
            stateCopy.companyMembers = stateCopy.companyMembers.map(m =>
                m.id === action.payload.id ? { ...m, ...action.payload } : m
            );
            return stateCopy;
        default:
            return stateCopy;
    }
}